"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withKeys = exports.separate = exports.interleave = void 0;
var react_1 = __importDefault(require("react"));
function interleave(array, separator) {
    var output = [];
    array.forEach(function (element, index) {
        if (index) {
            output.push(separator());
        }
        output.push(element);
    });
    return output;
}
exports.interleave = interleave;
function separate(array, interpunct) {
    return interleave(array, function () { return interpunct(); });
}
exports.separate = separate;
function withKeys(array) {
    return array.map(function (element, index) { return react_1.default.createElement(react_1.default.Fragment, { key: index }, element); });
}
exports.withKeys = withKeys;
